import React from 'react'
import Link from 'next/link'
import { has } from 'lodash'
import validator from 'validator'
import { cn } from '@/lib/utils'
import { assets } from '@/helpers/common'

const ResetForm = function ({ formData, ...props }) {
  return (
    <div className='login-form-box w-full py-10 px-16 xs:py-5 xs:px-5'>
      <form className='row' onSubmit={e => props.formOnSubmitHandler(e, props.resetObj)}>
        <div className='form-left w-4/12 md-mx:w-full flex flex-col justify-center'>
          <div className='section-title'>
            <h2>Forgot Password</h2>
            <p>Provide your registered email</p>
          </div>
          {props.resetSuccess === true && !validator.isEmpty(props.resetMessage) ? (
            <div className='pr-2 pb-5 text-left'>
              <p className='text-green-600 text-base font-medium'>{props.resetMessage}</p>
            </div>
          ) : (
            <div className='form-fields'>
              <div
                className={
                  has(props.formErrors, 'errors') && has(props.formErrors.errors, 'email')
                    ? 'input-group has-error'
                    : 'input-group'
                }
              >
                <input
                  type='text'
                  name='email'
                  className={cn('input-field')}
                  placeholder='Email Address'
                  value={formData.email}
                  autoComplete='off'
                  onChange={e => props.inputOnChangeHandler(e, props.resetObj)}
                />
                {has(props.formErrors, 'email') ? <span className='error'>{props.formErrors.email}</span> : ''}
              </div>
              <div className='input-group'>
                <button type='submit' className='btn btn-primary w-full'>
                  Reset My Password
                </button>
              </div>
              {props.loading ? (
                <div className='loading'>
                  <img src={assets('images/loading.svg')} alt={''} />
                </div>
              ) : (
                ''
              )}
            </div>
          )}
          <div className='input-group'>
            <p className=' text-sm15 text-primary mt-3'>
              {' '}
              Try Another Way{' '}
              <Link href='/login' className=' text-lg font-medium text-secondary underline'>
                Back to login
              </Link>
            </p>
          </div>
        </div>
        <div className='form-right w-8/12 md-mx:hidden text-center'>
          <img className='inline-block' src={assets('images/reset-password.png')} alt='login' />
        </div>
      </form>
    </div>
  )
}

export default ResetForm
